import DownloadApp from "@/components/shared/DownloadApp";
import Loading from "@/components/shared/Loading";
import SpecialList from "@/components/special/SpecialList";
import { ENV } from "@/core/config/env";
import { GET_PRODUCTS } from "@/core/graphql/queries/getProductList";
import { ProductItem } from "@/core/models/products/productList";
import { SearchProductRequest } from "@/core/models/products/productRequest";
import { initializeApollo } from "@/lib/apolloClient";
import { getString } from "@/lib/stringUtils";
import Head from "next/head";
import { useRouter } from "next/router";

interface ProductPageProps {
    products: ProductItem[];
    pagination: {
        count: number;
        currentPage: number;
        totalPages: number;
    };
}

export default function SpecialPage({ products, pagination }: ProductPageProps) {
    const router = useRouter();
    const { query, isReady } = router;

    if (!isReady) return <Loading />; // prevent undefined query on first render

    const searchParams = {
        category: getString(query.category),
        scope: getString(query.scope),
        saleType: getString(query.saleType),
        text: getString(query.text),
        page: query.page ? parseInt(query.page as string, 10) : 1,
    };
    const title = 'Find car spares specials | www.CarSparesEzyFind.co.za'
    const description = 'Find all your products, services and digital download specials to be purchased, auctioned or hired for car spares.'
    const keywords = 'purchase specials, hire specials, auction specials, bid specials, car spares specials'

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="title" content={title} />
                <meta name='description' content={description} />
                <meta name='keywords' content={keywords} />
            </Head>
            <div className="my-10">
                <div className="container">
                    <SpecialList
                        searchParams={searchParams}
                        initialProducts={products}
                        initialPagination={pagination}
                    />
                </div>
            </div>
            <DownloadApp />
        </>
    );
}


export const getStaticProps = async () => {
    const apolloClient = initializeApollo();
    const searchProductRequest: SearchProductRequest = {
        domainCategoryIds: String(ENV.CATEGORY_ID),
        page: 1,
        size: 12,
        salesTypeId: null,
        scopeId: 2 // Assuming 2 is the ID for "Special" scope
    };

    const { data: productData } = await apolloClient.query({
        query: GET_PRODUCTS,
        variables: searchProductRequest,
    });

    return {
        props: {
            products: productData?.getPrdProductList?.result ?? [],
            pagination: {
                count: productData?.getPrdProductList?.count ?? 0,
                currentPage: productData?.getPrdProductList?.currentPage ?? 1,
                totalPages: productData?.getPrdProductList?.totalPages ?? 0,
            },
        }
    };
};